import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
import Home from "@/components/home.vue";
import YSZC from "@/components/yszc.vue";
import FWTK from "@/components/fwtk.vue";
import en_fwtk from "@/components/en_fwtk.vue";
import en_yszc from "@/components/en_yszc.vue";
import Zhuxiao from "@/components/zhuxiao.vue";
const routes = [
    {
        path: "/",
        component: Home
    },
    {
        path: "/yszc",
        component: YSZC
    },
    {
        path: "/fwtk",
        component: FWTK
    },
    {
        path: "/en_yszc",
        component: en_yszc
    },
    {
        path: "/en_fwtk",
        component: en_fwtk
    },
    {
        path: "/zhuxiao",
        component: Zhuxiao
    }
]
const router = new VueRouter({
    mode: "history",
    routes
})

//修改原型对联 的push 

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router;